import ReactGA from "react-ga4";
import { authenticateApi } from "../services/mainAppService";

export const isDebug = () => {
    return process.env.REACT_APP_DEBUG !== 'false';
};


export const consoleToLog = (msg, value) => {
    if (isDebug()) console.log(msg, value);
};

export const showTriageType = (type) => {
    switch (type) {
        case 'email':
            return 'Email'

        case 'checklist_note':
            return 'Note'

        case 'approval':
            return 'Approval'
            
        default:
            break;
    }
}

export const sendEmailString = {
    TO : 'To',
    CC : 'Cc',
    BCC : 'Bcc'
}

export const displayEmailSubject = (emailSubject) => {
    return emailSubject ? emailSubject.replaceAll(/^Re:|Fwd:+/ig, '') : '';
}

export const OverlayMessage = {
    SEND_EMAIL: "Please wait. We are sending the email!"
}

export const sendApiPath = (reply, replyAll, forward) => {
    if(reply) return 'reply';
    if(replyAll) return 'replyAll';
    if(forward) return 'forward';
}

export const showIcons = (image_type) => {
    switch (image_type) {
        case 'triage':
            return '/images/clear-triage-icon.svg'

        case 'read':
            return '/images/mark-as-read-large.svg'

        case 'unread':
            return '/images/mark-as-unread-large.svg'

        case 'reply':
            return '/images/reply-icon.svg'

        case 'replyAll':
            return '/images/reply-all-icon.svg'

        case 'forward':
            return '/images/forward-icon.svg'

        case 'create-checklist':
            return '/images/create-checklist-icon.svg'

        case 'search':
            return '/images/search-icon.svg'

        case 'assign-checklist':
            return '/images/assign-checklist-icon.svg'

        case 'attachment':
            return '/images/attachment-img-icon.svg'

        case 'assign-client':
            return '/images/add-client-icon.svg'

        case 'sent-email':
            return '/images/sent-email.svg'
            
        case 'comment':
            return '/images/comment-icon.svg'

        case 'approve':
            return '/images/approved_icon.svg'

        case 'reject':
            return '/images/rejected_icon.svg'
        
        case 'cancel':
            return '/images/cancelled_icon.svg'

        default:
            break;
    }
}

export const trackGAEvent= (category, action, label) => {
    if(!isDebug()) {
        ReactGA.event({
            category: category,
            action: action,
            label: label
        });
    }
}

export const getInvoicePeriodicityPlaceholder= (periodictyType) => {
    if(periodictyType === "monthly"){
        return "per month";
    }
    else if(periodictyType === "quarterly"){
        return "per quarter";
    }
    else if(periodictyType === "half_yearly"){
        return "per half year";
    }
    else if(periodictyType === "yearly"){
        return "per year";
    }
    else return "";
}

export const capitalizeFirstLetterOfEachWord = (s) => {
    if (typeof s !== 'string') return '';
    return s.replace(/\b\w/g, l => l.toUpperCase());
}

export const inputNumberValidate = (e) => {
    const re = /[0-9]+/g;
    if (!re.test(e.key)) {
        e?.preventDefault();
    }
}

export const TriageTypes = {
    EMAIL : 'email',
    CHECKLIST_NOTE: 'checklist_note',
    CHECKLIST_TASK: 'checklist_task',
    APPROVAL: 'approval'
}

export const getStatusColor = (status) => {
    /**
    Completed       #72BB53(green)
    Awaiting Reply  #DC4C18(orange)
    In Progress     #FFA834(yellow)
    Pending         #929292(gray)       //default also
    Not Applicable  #929292(gray) with opacity
    */
    if (!status) return;
    var color = '#929292';
    switch (status) {
        case 'pending':
        case 'Pending':
        case 'not_applicable':
        case 'Not Applicable':
            color = '#929292';
            break;
        case 'in_process':
        case 'In Process':
            color = '#FFA834';
            break;
        case 'awaiting_reply':
        case 'Awaiting Reply':
            color = '#DC4C18';
            break;
        case 'completed':
        case 'Completed':
            color = '#72BB53';
            break;
        case 'pending_approval':
            color = '#000000';
            break;
        case 'over_due':
            color = 'red';
            break;    
        default:
            color = '#929292';
    }
    return color;
}

export const ApprovalStatus = {
    PENDING: 'NONE',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED'
}

export const ApprovalTypes = {
    CHECKLIST: 'checklist',
    TASK: 'task'
}


export const TaskStatusName = {
    PENDING: "Pending",
    PENDING_APPROVAL : "Pending Approval",
    AWAITING_REPLY: "Awaiting Reply",
    COMPLETED: "Completed"
}

export const approvalStatus = (status) => {
    switch (status) {
        case 'NONE':
            return {name: 'Pending', color: '#888888'};
        case 'APPROVED':
            return {name: 'Approved', color: '#3B961B'};
        case 'REJECTED':
            return {name: 'Rejected', color: '#DB4C3F'};
        case 'CANCELLED':
            return {name: 'Cancelled', color: '#333333'};
        default:
            return '';
    }

}

export const fetchAccessToken = async (service) => {
    try {
        const response = await authenticateApi(service);
        const data = await response.data;
        return data;
    } catch (error) {
        console.error('Error fetching access token:', error);
        throw error;
    }
};

export const EditorButtons = [
    "undo",
    "redo",
    "|",
    "font",
    "fontsize",
    "|",
    "bold",
    "italic",
    "strikethrough",
    "underline",
    "|",
    "align",
    "ul",
    "ol",
    "|",
    "outdent",
    "indent",
    "|",
    "table",
];

export const EditorConfig = {
    readonly: false,
    toolbar: true,
    spellcheck: true,
    language: "en",
    askBeforePasteHTML: false,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: "insert_clear_html",
    buttons: [...EditorButtons],
    placeholder: 'Type here',
    disablePlugins: 'add-new-line',
    cleanHTML: {
        fillEmptyParagraph: false,
        replaceNBSP:false
    },
    enter: 'BR',
    removeButtons: ['source', 'fullsize', 'about'],
    minHeight:300
}